import { Seg } from "@kitchen/ui";
import { useState } from "react";
import { AttendanceTab } from "./AttendanceTab.js";
import { DocumentsTab } from "./DocumentsTab.js";
import { NoticesTab } from "./NoticesTab.js";
import { PayTab } from "./PayTab.js";
import { PeopleTab } from "./PeopleTab.js";
import { PerformanceTab } from "./PerformanceTab.js";
import { PositionsTab } from "./PositionsTab.js";
import { ShiftsTab } from "./ShiftsTab.js";
import { TabletTab } from "./TabletTab.js";
import { TempWorkersTab } from "./TempWorkersTab.js";

export type HrTab =
  | "people"
  | "positions"
  | "documents"
  | "shifts"
  | "attendance"
  | "tablet"
  | "notices"
  | "tempWorkers"
  | "pay"
  | "performance";

export function HrPage() {
  const [tab, setTab] = useState<HrTab>("people");

  return (
    <div className="stack" style={{ gap: "var(--s4)" }}>
      <div className="row wrap" style={{ alignItems: "center" }}>
        <Seg<HrTab>
          label="بخش مدیریت منابع انسانی و پرسنل"
          value={tab}
          onChange={setTab}
          options={[
            { value: "people", label: "پرونده پرسنل" },
            { value: "positions", label: "سمت‌ها و شرح وظایف" },
            { value: "documents", label: "مدارک و انقضا" },
            { value: "shifts", label: "شیفت‌ها" },
            { value: "attendance", label: "حضور امروز" },
            { value: "tablet", label: "تبلت ورود" },
            { value: "notices", label: "پیام‌ها و نامه‌ها" },
            { value: "tempWorkers", label: "نیروهای موقت و روزمزد" },
            { value: "pay", label: "حقوق و دستمزد" },
            { value: "performance", label: "امتیاز عملکرد" },
          ]}
        />
      </div>

      {tab === "people" && <PeopleTab />}
      {tab === "positions" && <PositionsTab />}
      {tab === "documents" && <DocumentsTab />}
      {tab === "shifts" && <ShiftsTab />}
      {tab === "attendance" && <AttendanceTab />}
      {tab === "tablet" && <TabletTab />}
      {tab === "notices" && <NoticesTab />}
      {tab === "tempWorkers" && <TempWorkersTab />}
      {tab === "pay" && <PayTab />}
      {tab === "performance" && <PerformanceTab />}
    </div>
  );
}

export * from "./PeopleTab.js";
export * from "./PositionsTab.js";
export * from "./DocumentsTab.js";
export * from "./ShiftsTab.js";
export * from "./AttendanceTab.js";
export * from "./TabletTab.js";
export * from "./NoticesTab.js";
export * from "./TempWorkersTab.js";
export * from "./PayTab.js";
export * from "./PerformanceTab.js";
